module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الإهــداء"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهــداء")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إهداءٌ إلى كلِّ قلبٍ يحتضنُ التفاؤلَ بين ثناياه، إلى كلِّ سطرٍ يبعثُ الحبَّ من حروفه، إلى كلِّ عينٍ لا تبصرُ إلّا النور، إلى كلِّ شمعةٍ تصارع ظلامَ عالمنا، إلى كلِّ سفينةٍ لم تصل إلى موانئ السّعادة، إلى كلِّ غصنٍ لم يعانق أسرابَ الأحلام، إلى كلِّ قلم لم يعرف إلّا السوادَ لوناً،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى عالمنا..")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9da684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 66
// module chunks = 0